import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

const openBooking = () => window.dispatchEvent(new CustomEvent('openBooking'));

export default function CTASection() {
  const priceAnim = useScrollAnimation();
  const finalAnim = useScrollAnimation();

  return (
    <>
      {/* Price Promise — Boxt dark section style */}
      <section className="bg-[#3F4652] py-12 md:py-16">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div
            ref={priceAnim.ref}
            className={`flex flex-col md:flex-row items-center gap-8 md:gap-14 transition-all duration-700 ${priceAnim.visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
          >

            {/* Left: product image with badge */}
            <div className="relative flex-shrink-0 flex items-center justify-center w-full md:w-auto">
              <div className="relative w-full max-w-[320px] mx-auto">
                <img
                  src="https://public.readdy.ai/ai/img_res/d55f7051c992dabfbb837dddf6f13263.jpg"
                  alt="Our fixed price promise"
                  className="w-full rounded-2xl object-cover"
                />
                <div className="absolute bottom-3 left-3 w-24 h-24 rounded-full bg-[#145A32] border-4 border-[#7AC943] flex flex-col items-center justify-center text-white text-center leading-tight p-2">
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-price-tag-3-fill text-[#7AC943] text-base mb-0.5" />
                  </div>
                  <span className="text-[9px] font-bold uppercase tracking-tight">FIXED PRICE</span>
                  <span className="text-[10px] font-black uppercase">PROMISE</span>
                  <span className="text-[9px] font-bold uppercase tracking-tight">GUARANTEED</span>
                </div>
              </div>
            </div>

            {/* Right: text content */}
            <div className="flex-1 text-white text-center md:text-left">
              <h2 className="font-heading font-bold text-2xl md:text-3xl mb-3">
                The Renewables Made Easy Fixed Price Promise
              </h2>
              <p className="text-white/70 text-base leading-relaxed mb-5 max-w-lg mx-auto md:mx-0">
                We regularly review our prices to make sure we&apos;re giving you the best possible deal. The price we quote is the price you pay — we guarantee it with no hidden extras, ever.
              </p>
              <ul className="flex flex-col gap-2 mb-6 items-center md:items-start">
                {[
                  'No surprise costs on the day of install',
                  'Price holds for 30 days after your quote',
                  'Guaranteed like-for-like price match',
                ].map((item) => (
                  <li key={item} className="flex items-center gap-2 text-white/80 text-sm">
                    <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                      <i className="ri-check-line text-[#7AC943] text-base" />
                    </div>
                    {item}
                  </li>
                ))}
              </ul>
              <button
                onClick={() => document.getElementById('quote-section')?.scrollIntoView({ behavior: 'smooth' })}
                className="bg-gradient-to-r from-[#4CAF50] to-[#7AC943] text-white font-bold px-7 py-3.5 rounded-full text-sm hover:opacity-90 transition-all cursor-pointer whitespace-nowrap"
              >
                Get my fixed price
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Final CTA — dark green */}
      <section className="bg-[#145A32] py-12 md:py-14">
        <div className="max-w-7xl mx-auto px-4 md:px-8 text-center">
          <div
            ref={finalAnim.ref}
            className={`transition-all duration-700 ${finalAnim.visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
          >
            <h2 className="font-heading font-bold text-2xl md:text-4xl text-white mb-3">
              Ready to Get Started?
            </h2>
            <p className="text-white/70 text-base mb-7 max-w-lg mx-auto">
              Get your fixed price in seconds. No surveys, no hidden costs. Just a simple, honest quote.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <button
                onClick={() => document.getElementById('quote-section')?.scrollIntoView({ behavior: 'smooth' })}
                className="w-full sm:w-auto bg-gradient-to-r from-[#4CAF50] to-[#7AC943] text-white font-bold px-8 py-4 rounded-full text-base hover:opacity-90 transition-all cursor-pointer whitespace-nowrap"
              >
                Get My Quote &rarr;
              </button>
              <button
                onClick={openBooking}
                className="w-full sm:w-auto flex items-center justify-center gap-2 border-2 border-white/60 text-white font-bold px-8 py-4 rounded-full text-base hover:border-white hover:bg-white/10 transition-all cursor-pointer whitespace-nowrap"
              >
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-calendar-check-line text-[#7AC943]" />
                </div>
                Book an Appointment
                <span className="bg-[#f59e0b] text-white text-[9px] font-bold px-1.5 py-0.5 rounded-full">GHL</span>
              </button>
              <a
                href="tel:08001234567"
                className="w-full sm:w-auto flex items-center justify-center gap-2 border-2 border-white/40 text-white font-bold px-8 py-4 rounded-full text-base hover:border-white transition-all cursor-pointer whitespace-nowrap"
              >
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-phone-fill text-[#7AC943]" />
                </div>
                Call: 0800 123 4567
              </a>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
